<template>
  <div class="hidden-component">
    <input type="hidden"
           v-model="formData.fields[field.id].value"
           :id="field.id"
           :name="field.id">
  </div>
</template>

<script>
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'

  export default {
    name: 'hidden-component',
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      }
    },
    created () {
      let fieldData = this.formData.fields[this.field.id]
      fieldData.value = fieldData.value || false
    }
  }
</script>
